export default "__VITE_ASSET__CI8Ko0MT__"